import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "SEO Content Strategy", desc: "Keyword clusters and editorial plans engineered for durable organic growth." },
  { title: "Sales Copywriting", desc: "Landing page and offer copy tuned to objections, intent, and conversion." },
  { title: "Authority Articles", desc: "Thought-leadership content that builds trust with buyers and search engines." },
  { title: "Product Messaging", desc: "Clear feature-to-benefit narratives that make complex products easy to buy." },
  { title: "Lifecycle Content", desc: "Email and nurture sequences that move prospects from first click to close." },
  { title: "Editorial Operations", desc: "Governance, style systems, and production workflows for consistent publishing." },
];

const ContentWriting = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Words that"
    titleAccent="convert and rank."
    subtitle="Strategic content systems for growth-stage brands that need discoverability, credibility, and pipeline impact."
    features={features}
    ctaLabel="PLAN CONTENT ENGINE"
  />
);

export default ContentWriting;